import { render, staticRenderFns } from "./ys.vue?vue&type=template&id=0e2e347c&scoped=true"
import script from "./ys.vue?vue&type=script&lang=js"
export * from "./ys.vue?vue&type=script&lang=js"
import style0 from "./ys.vue?vue&type=style&index=0&id=0e2e347c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2e347c",
  null
  
)

export default component.exports